import React from "react";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import { Helmet } from "react-helmet";

const EmployeeInformation = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Çalışan Adayı Aydınlatma Metni - LENSA
        </title>
        <meta
          name="description"
          content="Çalışan Adayı Aydınlatma Metnini bu sayfayı ziyaret ederek inceleyebilirsiniz."
        />
      </Helmet>
      <CustomBanner
        title="Çalışan Adayı Aydınlatma Metni"
        breadTitle="Çalışan Adayı Aydınlatma Metni"
        image={Banner}
      />
      <div className="container py-20">
        <div className="prose max-w-none">
          <h1 className="text-center text-2xl font-semibold mb-5">
            Çalışan Adayı Kişisel Verilerinin İşlenmesine İlişkin Aydınlatma
            Metni
          </h1>
          <p>
            Aşağıda yer alan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma
            Metni’ni okuyarak kişisel verilerinizi işleme amacımızı ve bu
            kapsamda haklarınızı ayrıntılarıyla incelemenizi rica ediyoruz.
          </p>
          <h2 className="font-semibold my-2">Veri Sorumlusu</h2>
          <p>
            6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) uyarınca,
            kişisel verileriniz; veri sorumlusu olarak LENSA Bilişim
            Teknolojileri Sanayi ve Ticaret Anonim Şirketi (“Şirket”) tarafından
            aşağıda açıklanan kapsamda işlenecektir.
          </p>
          <h3 className="font-semibold my-2">
            Kişisel Verileri Toplama Yöntemleri ve Hukuki Sebepleri
          </h3>
          <p>
            Şirketimiz, kişisel verileri doğrudan çalışan adaylarının
            kendisinden, çevrimiçi CV paylaşım platformlarından, çalışan
            adayının pozisyona uygunluk için değerlendirildiği süre kapsamında
            mülakat ve Şirketimiz tarafından gönderilen test sonuçlarından,
            e-posta, posta, faks ve sair iletişim kanalları aracılığıyla
            işitsel, elektronik veya yazılı olarak öğrenilen verilerden,
            Kanun’da belirtilen kişisel veri işleme şartlarına uygun olarak, iş
            başvuru sürecinin yönetilmesi ve icrası, insan kaynakları sürecinin
            planlanması ve icrası amaçları başta olmak üzere aşağıda belirtilen
            amaçlarla uyumlu olarak işlemektedir.
          </p>
          <p>
            Kişisel verileriniz, sizlerle bir sözleşme ilişkisi kurmamız veya bu
            sözleşmeden kaynaklanan ifa yükümlülüğümüz ile doğrudan doğruya
            ilgili olması kaydıyla, sizlere ait kişisel verilerin işlenmesinin
            gerekli olması (örneğin sözleşme öncesi müzakere dönemi nedeniyle
            veri işlenmesi), hukuki yükümlülüğümüzü yerine getirebilmek için
            zorunlu olan durumlar, kanunlarda öngörülen süreçlerin yürütülmesi,
            Şirketin ilgili mevzuat çerçevesindeki hukuki yükümlülüklerini
            yerine getirebilmesi, Şirket ile aranızda oluşabilecek muhtemel iş
            sözleşmesinin ifası, Şirket haklarınızı her zaman ön planda tutarak
            meşru menfaatini sağlayabilmesi (örneğin en uygun pozisyona en uygun
            adayın yerleştirilmesi için mülakatların yapılması) hukuki
            sebepleriyle işlenmektedir.
          </p>
          <h3 className="font-semibold my-2">
            Kişisel Verileri İşleme Amaçları
          </h3>
          <p>
            Yukarıda belirtilen kişisel verileriniz, bu verileri bizlere
            açıklamanıza konu olan ve aşağıda sıralanan amaçlarla
            işlenebilecektir:
          </p>
          <ul>
            <li>
              İnsan Kaynakları Süreçlerinin Planlanması ve İcrası, Çalışan
              Adayı/Stajyer/Öğrenci Seçme ve Yerleştirme Süreçlerinin
              Yürütülmesi, Çalışan Adaylarının Başvuru Süreçlerinin Yürütülmesi,
              İş Faaliyetlerinin Etkinlik/Verimlilik ve/veya Yerindelik
              Analizlerinin Gerçekleştirilmesi Faaliyetlerinin Planlanması
              ve/veya İcrası temel amaçlarıyla,
            </li>
            <li>
              İş başvuru talebinizin ve ilgili pozisyona uygunluğunuzun
              değerlendirilmesi çerçevesinde işe alım süreçlerinin yürütülmesi,
              sonuçlandırılması ve bu kapsamda sizinle veya bize referans olarak
              belirttiğiniz kişilerle iletişime geçilmesi ve tarafımıza
              paylaştığınız bilgilerin doğrulunun teyidi, iş görüşmeleri
              esnasında kişinin beyan ettiği tecrübelerinin, eğitim durumunun,
              yetkinliklerinin araştırma, gözlem ve kaydının yapılması, istihdam
              edilecek çalışan adayının görevlendirileceği ilgili departmanın iş
              koşullarına uygun eğitim, nitelik ve becerilerinin mevcudiyetinin
              tespiti, işle bağlantılı belirli fonksiyonlar açısından özel
              risklerin tespiti, iş görüşmesinin olumsuz sonuçlanması durumunda
              ilerleyen dönemlerde oluşabilecek uygun pozisyonlar için
              değerlendirilmesi, ücret bilgi ve skalasının belirlenmesi,
              iletişimin sağlanması, Şirketimiz insan kaynakları politikaları ve
              süreçlerinin planlanması ve icra edilmesi kapsamında; personel
              temin süreçlerinin yürütülmesi, mükerrer başvuruların takibi,
              şirket çalışanları için iş akdi ve/veya mevzuattan kaynaklı
              yükümlülüklerin yerine getirilmesi, çalışanlar için yan haklar ve
              menfaatlerin planlanması ve icrası, yetenek-kariyer gelişimi
              faaliyetlerinin planlanması ve icrası amaçlarıyla.
            </li>
          </ul>
          <h3 className="font-semibold my-2">Kişisel Verilerin Aktarılması</h3>
          <p>
            Şirketimiz, Kanun’un 4.maddesinde belirtilen ilkelere uygun olarak
            ve gerekli teknik ve idari güvenlik tedbirlerini yerine getirerek
            kişisel verilerinizi işlemeye özen göstermektedir. İş
            faaliyetlerinin yürütülmesi veya denetimi, iş sürekliliğinin
            sağlanması, dijital altyapıların işletilmesi farklı paydaşlarla
            sürekli veri akışını zaruri kıldığı için işlediğimiz kişisel
            verileri belirli amaçlarla üçüncü kişilerle aktarmak durumundayız.
          </p>
          <p>
            Kişisel verileriniz, yukarıda belirtilen amaçların
            gerçekleştirilmesi doğrultusunda ve bu amaçların yerine getirilmesi
            ile sınırlı olarak; LENSA grup şirketleri ile, iş ortaklarımızla,
            LENSA olarak iş faaliyetlerinde uygunluk değerlendirilmesi
            yapılabilmesi adına müşterilerimiz ile; beyan ettiğiniz bilgilerin
            teyidi amacıyla referans olarak belirtilen kişilerle, ilgili iş
            ortaklarımız, danışmanlarımız ve hizmet sağlayıcılarımızla, insan
            kaynakları ve istihdam alanında teknik danışmanlık aldığımız
            taraflarla, bilişim altyapımızı sağlayan, işleten veya hizmet sunan
            iş ortaklarımızla ve hizmet sağlayıcılarımızla, kanunen yetkili kamu
            kurumları ve özel kişi veya kuruluşlar ile, veri sorumlusunun meşru
            menfaatinin gerektirdiği hallerde özel olarak belirlenecek üçüncü
            kişiler ile işbu aydınlatma metninde belirtilen amaçlarla sınırlı
            olarak paylaşılabilecek veya işlenebilecektir.
          </p>
          <h3 className="font-semibold my-2">İlgili Kişinin Hakları</h3>
          <p>
            Kişisel veri sahibi olarak, KVKK’nın ilgili kişinin haklarını
            düzenleyen 11. maddesi kapsamındaki haklarınızı Veri Sorumlusuna
            Başvuru Usul ve Esasları Hakkında Tebliğ’e göre kullanmak için
            Kaptanpaşa Mahallesi Halit Ziya Türkkan Sokak No: 19/1
            Şişli/İSTANBUL adresine yazılı olarak iletebilir veya{" "}
            <a href="mailto:info@LENSA.com.tr">info@LENSA.com.tr</a> e-posta
            adresine e-posta yoluyla veya{" "}
            <a href="mailto:LENSA.bilisim@hs01.kep.tr">
              LENSA.bilisim@hs01.kep.tr
            </a>{" "}
            KEP adresimize güvenli elektronik imza veya mobil imzalı olarak
            başvurabilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeInformation;
